const widgetData = [
  {
    icon: 'grid',
    value: 210,
    text: 'Total Tasks',
  },
  {
    icon: 'check-square',
    value: 121,
    text: 'Total Tasks Completed',
  },
  {
    icon: 'users',
    value: 12,
    text: 'Total Team Size',
  },
  {
    icon: 'clock',
    value: 2500,
    text: 'Total Hours Spent',
  },
]

const projectActivity = [
  {
    id: 1,
    avatar: '09',
    title: 'Bryan',
    text: 'Neque porro quisquam est',
    color: 'primary',
  },
  {
    id: 2,
    avatar: '08',
    title: 'Everett',
    text: 'Ut enim ad minima veniam quis velit',
    color: 'success',
  },
  {
    id: 3,
    avatar: '08',
    title: 'Richard',
    text: 'Quis autem vel eum iure',
    color: 'warning',
  },
  {
    id: 4,
    avatar: '08',
    title: 'Jery',
    text: 'Quis autem vel eum iure',
    color: 'info',
  },
  {
    id: 5,
    avatar: '07',
    title: 'Bryan',
    text: 'Neque porro quisquam est',
    color: 'primary',
  },
  {
    id: 6,
    avatar: '06',
    title: 'Everett',
    text: 'Ut enim ad minima veniam quis velit',
    color: 'success',
  },
  {
    id: 7,
    avatar: '05',
    title: 'Richard',
    text: 'Quis autem vel eum iure',
    color: 'warning',
  },
]

export { widgetData, projectActivity }
